<template>
  <div class="userList">
    <el-table
      stripe
      :data="preparedUsers"
      ref="table"
      highlight-current-row
      :height="tableHeight"
      @current-change="handleCurrentChange"
      :cell-style="getCellStyle"
    >
      <el-table-column
          v-for="{ name, property, fixed, width } in columns"
          :prop="name"
          :label="name"
          :fixed="fixed"
          :width="width || 155"
      >
        <template #default="scope">
          <div
            class="cell-content"
            v-html="formatCellValue(get(scope.row, property || name))"
          />
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import {TableV2SortOrder} from "element-plus";
import {get, clone, cloneDeep} from 'lodash';


export default {
  props: ['users'],

  data() {
    return {
      sortState: {
        key: 'created_at',
        order: TableV2SortOrder.DESC,
      },
    }
  },

  computed: {
    sortedUsers() {
      const { key, order } = this.sortState

      const result = [...this.users]

      result.sort((a, b) => {
        if(order === 'desc') {
          const tmp = b
          b = a
          a = tmp
        }

        if(key.endsWith('_at') || key.endsWith('_date')) {
          return new Date(a[key]) - new Date(b[key])
        } else if(typeof a[key] === 'string' || typeof b[key] === 'string') {
          return String(a[key]).localeCompare(String(b[key]))
        } else {
          return a[key] - b[key]
        }
      })

      return result
    },

    preparedUsers() {
      return [...this.sortedUsers].map(originalRow => {
        const row = cloneDeep(originalRow)

        if(!row.profile_view_info) {
          return row
        }

        const { phone, email } = row
        const { own_phone, own_email, work_phone, work_email, last_name } = row.profile_view_info

        if(own_phone && own_phone !== phone) {
          row.phone += '<br/>' + own_phone
        }

        if(own_email && own_email !== email) {
          row.email += '<br/>' + own_email
        }

        if(last_name) {
          row.profile_view_info.first_name += ' ' + last_name
        }

        return row
      })
    },

    tableHeight() {
      return window.innerHeight * 0.8
    },
    columns() {
      return [
        { name: 'created_at', fixed: true},
        { name: 'email', },
        { name: 'phone', },
        // { name: 'first_phone', },
        {name: 'personal_companies'},
        // { name: 'first_email', },
        { name: 'full name', property: 'profile_view_info.first_name'  },
        // { name: 'last_name', },
        { name: 'nickname', },
        { name: 'last_login_at', },
        { name: 'active_space_company_id', },

        { name: 'id', },
      ]
    }
  },

  methods: {
    get,
    onSort(sortBy) {
      this.sortState = sortBy
    },
    handleCurrentChange(row) {
      this.$refs.table.setCurrentRow(row)
    },
    formatCellValue(value) {
      if (value === null || value === undefined || value === '') {
        return '<span class="cell-empty">—</span>'
      }
      return value
    },
    getCellStyle(cell) {
      const baseStyle = {
        padding: '8px 12px',
        fontSize: '13px',
        lineHeight: '1.4'
      }

      if (cell.column.property === 'active_space_company_id' && !!cell.row.active_space_company_id) {
        return {
          ...baseStyle,
          backgroundColor: '#e6f7ff',
          color: '#1890ff'
        }
      }

      return baseStyle
    }
  },

  watch: {
    sortState() {
      this.sortUsers()
    },
  },

}
</script>
<style scoped>
.userList {
  overscroll-behavior-y: none;
}

.cell-content {
  word-break: break-word;
  line-height: 1.4;
}

:deep(.cell-empty) {
  color: #c0c4cc;
  font-style: italic;
}

:deep(.el-table) {
  font-size: 13px;
}

:deep(.el-table th) {
  background-color: #f5f7fa;
  font-weight: 600;
  color: #606266;
}

:deep(.el-table td) {
  border-bottom: 1px solid #ebeef5;
}

:deep(.el-table--striped .el-table__body tr.el-table__row--striped td) {
  background-color: #fafafa;
}

:deep(.el-table__body tr.current-row > td) {
  background-color: #ecf5ff !important;
}

:deep(.el-table__body tr:hover > td) {
  background-color: #f5f7fa !important;
}
</style>
